/* Buy-column accordion. The description is split by <h6>, but splitting the raw
   HTML string breaks whenever the merchant wrapped it in containers: the stray
   closing tags escape our own elements and the last item falls out of the column.
   So the browser parses the description once, in a <template>, and we move the
   real nodes into place — balanced by construction, whatever the wrapping. */
(function () {
  /* Any wrapper that holds a heading is unwrapped, so every <h6> ends up a sibling
     of its own content. Without this, a heading nested one level deeper gets moved
     into the previous item's body and loses its content. */
  function flatten(root) {
    var again = true;

    while (again) {
      again = false;
      Array.prototype.slice.call(root.children).forEach(function (child) {
        if (child.tagName === 'H6' || !child.querySelector('h6')) return;
        while (child.firstChild) root.insertBefore(child.firstChild, child);
        root.removeChild(child);
        again = true;
      });
    }
  }

  function bodyAfter(head) {
    var body = document.createDocumentFragment();
    var node = head.nextSibling;

    // stops at the next heading, or at the end of this heading's own parent when
    // each section sits in a wrapper of its own
    while (node && !(node.nodeType === 1 && node.tagName === 'H6')) {
      var next = node.nextSibling;
      body.appendChild(node);
      node = next;
    }
    return body;
  }

  function item(title, body, name, icon) {
    var details = document.createElement('details');
    details.className = 'sh-buy__acc-item';
    if (name) details.setAttribute('name', name);

    var head = document.createElement('summary');
    head.className = 'sh-buy__acc-head';

    var label = document.createElement('span');
    label.textContent = title;
    head.appendChild(label);
    if (icon) head.appendChild(icon.cloneNode(true));

    var content = document.createElement('div');
    content.className = 'sh-buy__acc-body rte';
    content.appendChild(body);

    details.appendChild(head);
    details.appendChild(content);
    return details;
  }

  function build(root) {
    var source = root.querySelector('template[data-sh-acc-source]');
    if (!source) return;

    var parsed = document.createElement('div');
    parsed.appendChild(source.content.cloneNode(true));

    var iconTemplate = root.querySelector('template[data-sh-acc-icon]');
    var icon = iconTemplate ? iconTemplate.content : null;
    var name = root.getAttribute('data-sh-acc-name') || '';

    flatten(parsed);

    var heads = parsed.querySelectorAll('h6');
    var built = document.createDocumentFragment();

    if (heads.length) {
      // document order, and each pass removes its own nodes as it goes
      Array.prototype.forEach.call(heads, function (head) {
        var title = head.textContent.trim();
        var body = bodyAfter(head);
        if (title && body.textContent.trim()) {
          built.appendChild(item(title, body, name, icon));
        }
      });
    } else {
      var label = root.getAttribute('data-sh-acc-label') || '';
      var all = document.createDocumentFragment();
      while (parsed.firstChild) all.appendChild(parsed.firstChild);
      built.appendChild(item(label, all, name, icon));
    }

    if (!built.childNodes.length) return;

    while (root.firstChild) root.removeChild(root.firstChild);
    root.appendChild(built);
  }

  function boot() {
    document.querySelectorAll('[data-sh-accordion]').forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
